export const APP_NAME = "EmpowerCare";
export const APP_VERSION = "0.1";
export const LOGIN_PATH = "/login";
export const HOME_PATH = "/";
export const SIGNUP_PATH = "signup";
export const signupAsClinicianPath = "signupAsClinician?USER_TYPE=clinician";
export const signupAsFacilityPath = "signupAsFacility?USER_TYPE=facility";
export const GoogleAutoCompleteKey = "AIzaSyCNe-x9Jn_2903j9PxhLPw6SPGXMwIlkCM";
export const STRIPE_PUBLISHED_KEY = "pk_test_51Qpr57JcPf3peILsgsVGsuqsnHFKw7ooJTt8l57DQkb4TbRjONF7CZNiwhrXuzSxrjDGsK7RNqLID1Zm4qfqf4Md001rYGcbqw"
export const SESSION_TIMEOUT = 40 * 60 * 1000; // 10 minutes
export const WARNING_BEFORE = 1 * 60 * 1000;   // 1 minute before timeout
 
// LOCAL ENVIRONMENT
// export const FRONTEND_URL = "http://localhost:3000/";
// export const API_URL = "http://localhost:5001/api/";
// export const SOCKET_URL = "http://localhost:5001/";
 
 
// export const FRONTEND_URL = "http://192.168.5.232:3000/";
// export const API_URL = "http://192.168.5.232:5001/api/";
// export const SOCKET_URL = "http://192.168.5.232:5001/";
 
// TEST ENVIRONMENT
// export const FRONTEND_URL = "http://10.30.25.39:5001/";
// export const API_URL = "http://10.30.25.39:5001/api/";
// export const SOCKET_URL = "http://10.30.25.39:5001/";
 
// Production Environment
export const API_URL = "https://app.empowercare.us/api/";
// export const API_URL = "http://localhost:8080/api/";
export const FRONTEND_URL = "https://app.empowercare.us/";
export const SOCKET_URL = "https://app.empowercare.us";
// export const SOCKET_URL = "http://localhost:5001/";
  
export const ADMIN_ID = "77174e9e-dcb8-4ecb-bdd0-9109288cb25c"; // Admin ID for special permissions
 
 
// SSL Production Environment21
// export const API_URL = "https://meanstack.smartdatainc.com:9285/api/";
// export const FRONTEND_URL = "https://meanstack.smartdatainc.com:9285/";
// export const SOCKET_URL = "https://meanstack.smartdatainc.com:9285/";